var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapActions, mapGetters } from 'vuex';
import { LOCATION, FRANCHISOR } from '@/stores/defs';
import locationService from '@/services/location.service';
import Promise from 'promise-polyfill';
var locationsMixin = {
    computed: __assign({}, mapGetters({
        location: LOCATION.GET_LOCATION,
        getLocations: LOCATION.GET_LOCATIONS,
        franchisor: FRANCHISOR.GET_FRANCHISOR,
        allCoordinates: LOCATION.GET_ALL_COORDINATES,
    }), { storeName: function () {
            return this.$appConstants.storeName;
        },
        storeLocality: function () {
            var location = this.location;
            if (typeof location.getLocality !== 'function') {
                return '-';
            }
            return location.getLocality();
        },
        storePhone: function () {
            var location = this.location;
            return location.contactPhone;
        },
        hasSelectedLocation: function () {
            var location = this.location;
            if (!location) {
                return false;
            }
            var id = location.id;
            if (!id) {
                return false;
            }
            var storeTag = id.split('~')[0];
            var isFranchise = storeTag.match(/c+\d/);
            if (isFranchise) {
                return false;
            }
            return true;
        },
        // TODO implement _destinationName (returns delivery address or pickup address)
        _locationId: function () {
            return this.location && this.location.id;
        } }),
    methods: __assign({}, mapActions({
        setLocation: LOCATION.SET_LOCATION,
        setLocations: LOCATION.SET_LOCATIONS,
    }), { getAllLocations: function () {
            return locationService.getLocations();
        },
        getUserLocation: function () {
            return new Promise(function (resolve, reject) {
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        return resolve(position);
                    });
                }
                else {
                    return reject('Location access Denied');
                }
            });
        },
        getLocationDetails: function (locations) {
            var locationDetails = locationService.convertToLocationDetails(locations);
            return locationDetails;
        },
        getFranchisorCoordinates: function () {
            var franchisor = this.franchisor;
            // TODO Can't get coordinates based on model
            return {
                latitude: 0,
                longitude: 0,
            };
        },
        getLocationsSuccessResponse: function (result) {
            var data = result.data;
            var body = data && data.body;
            var nearby = body && body.sections.Nearby;
            return { nearby: nearby };
        },
        getAllCoordinates: function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                locationService.getLocations().then(function (result) {
                    var nearby = _this.getLocationsSuccessResponse(result).nearby;
                    _this.setLocations(nearby);
                    var coordinates = _this.allCoordinates;
                    resolve(coordinates);
                });
            });
        },
        getLocationFromBase: function (locationBase) {
            var currentLocation = this.location;
            var currentBase = currentLocation.id;
            if (currentBase && locationBase === currentBase) {
                return new Promise(function (resolve) {
                    resolve(currentLocation);
                });
            }
            return locationService.getSingleLocation(locationBase);
        },
        _getCurrentLocation: function () {
            var currentLocation = this.location;
            if (locationService.isLocationType(currentLocation)) {
                return new Promise(function (resolve) {
                    resolve(currentLocation);
                });
            }
            var base = locationService.base;
            return locationService.getSingleLocation(base);
        } }),
};
export default locationsMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/locationsMixin.ts
// module id = Irlj
// module chunks = 18